module.exports = __webpack_public_path__ + "static/media/thiago-oliveira.d9ae65ee.png";